import { render, staticRenderFns } from "./DemoExams.vue?vue&type=template&id=893cd17e"
import script from "./DemoExams.vue?vue&type=script&lang=js"
export * from "./DemoExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports